import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { SharedService } from 'src/app/core/services/shared.service';
import Swal from 'sweetalert2';

import { SidebarComponent } from '@syncfusion/ej2-angular-navigations';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  @Input() strWsURL: string = '';
  @Input() strSYS02TIP: string = '';
  @Input() JSONllavesMantenimiento: string = '';

  Paneles: any;
  Tablas: any;
  Graficos = [];
  Reportes = [];
  PanelesS38 = [];
  Filtros: any;
  arrFiltros = "";
  SYS33CON: number;
  SYS33DES: string;

  blnRefresh: boolean = true;

  constructor(private dataService: SharedService) {
  }

  ngOnInit() {
    this._fetchData();
  }

  @ViewChild('sidebar') sidebar?: SidebarComponent;
  public type: string = 'Push';
  public onCreated(args: any) {
    (this.sidebar as SidebarComponent).element.style.visibility = '';
    this.sidebar?.hide();
  }

  toggleClick(): void {
    this.sidebar?.toggle();
  }

  private _fetchData() {
    this.dataService.ConsultarWS(this.strWsURL).subscribe(
      (datosResp: any) => {
        this.Paneles = datosResp.Paneles;
        this.Tablas = datosResp.Tablas;
        this.Graficos = datosResp.Graficos;
        this.Reportes = datosResp.Reportes;
        this.PanelesS38 = datosResp.PanelesS38;
        this.Filtros = datosResp.Filtros;
        this.SYS33CON = datosResp.SYS33CON;
        this.SYS33DES = datosResp.SYS33DES;
      },
      error => {
        Swal.fire({
          html: '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
            '<div class="col-4">' +
            ' <img src="assets/images/imageerror.png"> </img>' +
            '</div>' +
            ' <div class="col-8">' +
            '<h3>Error</h3><br>' +
            ' <p>' + error + '</p>' +
            ' </div> ',
        })
        localStorage.setItem(this.strWsURL, "{}");
      }
    );
  }

  FiltrosOnChange(form) {
    this.blnRefresh = true;
    this.arrFiltros = form;
    this.sidebar?.hide();
  }
}
